// extracted by mini-css-extract-plugin
export default {"animatedIconFail":"AnimatedIconFail-module__animatedIconFail__laniz"};